export default "__VITE_ASSET__BUcz3lsE__"